import React from 'react';
import Layout from '../../../components/Layout';
import ServicesLayout from '../../../components/ServicesLayout';
import UpdateEmuia from './updateEmuia';

import { isAdminUser } from '../../../lib/utils';

const title = 'Zarządzanie Urzędami';

export default {
  path: '/update_emuia',
  async action(ctx) {
    const isAdmin = await isAdminUser(ctx);
    if (!isAdmin) {
      return { redirect: '/' };
    }
    return {
      title,
      chunk: 'districts',
      component: (
        <ServicesLayout isAdmin>
          <UpdateEmuia title={title} />
        </ServicesLayout>
      ),
    };
  },
};



// WEBPACK FOOTER //
// src/routes/admin/update_emuia/index.js